import { Anchor, Building2, Users, Warehouse } from 'lucide-react';
import { LOCATION, LOCATION_TITLE_KEYS } from './types';

export const LOCATION_TYPES = {
  [LOCATION.W]: { Icon: Warehouse, label: LOCATION_TITLE_KEYS.W, color: 'text-blue-500' },
  [LOCATION.P]: { Icon: Anchor, label: LOCATION_TITLE_KEYS.P, color: 'text-green-500' },
  [LOCATION.C]: { Icon: Users, label: LOCATION_TITLE_KEYS.C, color: 'text-orange-500' },
  [LOCATION.S]: { Icon: Building2, label: LOCATION_TITLE_KEYS.S, color: 'text-purple-500' }
} as const;

export type LOCATION_TYPES = (typeof LOCATION_TYPES)[keyof typeof LOCATION_TYPES];
